import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Routes, Route } from "react-router-dom";

import "./pgpTools.css";
import { auth } from "../../components/firebase/firebase";

import PgpToolsStart from "./views/PgpToolsStart";

function PgpTools() {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/login");
  }, [user, loading]);

  return (
    <div className="PgpTools">
      <Routes>
        <Route path="/" element={<PgpToolsStart />} />
      </Routes>
    </div>
  );
}

export default PgpTools;
